import { State } from "./types";

// eslint-disable-next-line no-useless-escape
export const loginPatt = /^(?:[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)(?!.)/;

// eslint-disable-next-line no-useless-escape
export const namePatt = /^(?:[A-Za-z0-9!#$%&"();:,<>@'*+\/\[\]\\=?^_`{|}~-]*)(?!.)/;

// eslint-disable-next-line no-useless-escape
export const passwordPatt = /^(?=.*[a-zA-z0-9_а-яА-я])(?=.{6,})/;

export const AVAILEBLE_EMAIL_DOMAINS = ["basf.com", "partners.basf.com", "metanomics.de", "sm-analytics.com", "vegetableseeds.basf.com", "smartanalytics.ru"];

export const INITIAL_STATE: State = {
  login: "",
  name: "",
  surname: "",
  department: 1,
  showPassword: {
    password: false,
    confirmPassword: false,
  },
  errors: {
    login: false,
    password: false,
    confirmPassword: false,
    name: false,
    surname: false,
    department: false,
    domain: false,
  },
  showErrorMessage: false,
};
